import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import CardHeader from "../../Common/CardHeader/CardHeader";
import search from "../../assets/images/search-lg.svg";
import DeleteMembership from "../Membership/DeleteMembership";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { deleteTopUp, getPopUpList } from "../../../redux/topup/actions";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";

const AddOnList = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [modal, setModal] = useState(false);
  const [modals, setModals] = useState(false);

  const [currentComponent, setCurrentComponent] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openFilter, setOpenFilter] = useState(false);

  const [params, setParams] = useState({
    search_key: "",
    page: 1,
    parent_id: 1,
  });
  const membershipList = useSelector(
    (state) => state?.reusableSlice?.thePopUpList
  );


  useEffect(() => {
    dispatch(getPopUpList(params, setIsLoading))
  }, [dispatch, params]);

  const updateComponent = (id) => {
    navigate(`/updatetopup/${id}`);
  };

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteTopUp(currentComponent?.id, setIsLoading));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  return (
    <div>
      <div className="p-3">
        <div className="category-wrapper d-flex justify-content-center flex-column w-100">
          <div className="d-flex justify-content-between align-items-center sub-head">
            <h4>Top-Up list</h4>
            <button
              className="border-button"
              onClick={() => navigate("/addtopup")}
            >
              <span>Create Top-Up</span>
            </button>
          </div>
        </div>
      </div>
     {isLoading ? <FullScreenLoader/>:
      <CardBody className="table-sec px-3">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Title</th>
              <th scope="col">Price</th>
              {/* <th>Discount</th> */}
              {/* <th>Plan Type</th> */}
              {/* <th>Duration</th> */}
              <th scope="col">Status</th>
              <th scope="col" className="text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {membershipList?.memberships?.length > 0 ? (
              membershipList?.memberships?.map((item, index) => (
                <tr key={index}>
                  <td> {index + 1 + (params?.page - 1) * 10}</td>
                  <td>{item?.title} </td>
                  <td>{item?.price} </td>
                  {/* <td>{item.discount}</td> */}
                  {/* <td>{item?.duration_type === 1 ? "Month": item?.duration_type === 2 ? "Yearly": "Days"}</td> */}
                  {/* <td>{item.duration}</td> */}
                  <td>
                    {item?.status == 1
                      ? "Active"
                      : item?.status == 2
                      ? "Inactive"
                      : ""}
                  </td>
                  <td>
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ columnGap: "10px" }}
                    >
                      <button
                        className="border-button"
                        onClick={() => updateComponent(item?.id)}
                      >
                        <span>Update</span>
                      </button>
                      <button
                        className="background-button"
                        onClick={() => {
                          setModal(true);
                          setCurrentComponent(item);
                        }}
                      >
                        <span>Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No Add-ons Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CardBody>}
      <CommonPagination
        params={params}
        setParams={setParams}
        pagination_meta={membershipList?.pagination_meta}
      />
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <DeleteMembership
          modalTitle="Add-On"
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        ></DeleteMembership>
      </Modal>
    </div>
  );
};

export default AddOnList;
